import {apiFetch} from 'src/api/fetch'

import {
    type ApplyStockEquipmentAssignmentDeltaInput,
    applyStockEquipmentAssignmentDeltaInputSchema,
    type ApplyStockEquipmentReassignmentInput,
    applyStockEquipmentReassignmentInputSchema,
    mapStockEquipmentAssignmentSummary,
    type StockEquipmentAssignmentSummary,
    stockEquipmentAssignmentSummaryRawSchema,
} from './schemas'

export async function getAssignableStockEquipment(
    jobId: string,
    rentalAssetTypeId: string,
): Promise<StockEquipmentAssignmentSummary> {
    const params = new URLSearchParams({rental_asset_type_id: rentalAssetTypeId})
    const raw = await apiFetch<unknown>(
        `/jobs/${jobId}/assignable-stock-equipment?${params.toString()}`,
    )
    const parsed = mapStockEquipmentAssignmentSummary(
        stockEquipmentAssignmentSummaryRawSchema.parse(raw),
    )
    return parsed
}

export async function applyStockEquipmentAssignmentDelta(
    jobId: string,
    input: ApplyStockEquipmentAssignmentDeltaInput,
): Promise<StockEquipmentAssignmentSummary> {
    const body = applyStockEquipmentAssignmentDeltaInputSchema.parse(input)
    const raw = await apiFetch<unknown>(`/jobs/${jobId}/stock-equipment-assignments`, {
        method: 'POST',
        body: JSON.stringify({
            rental_asset_type_id: body.rentalAssetTypeId,
            delta: body.delta,
            third_party_rental_asset_offering_id: body.thirdPartyRentalAssetOfferingId,
        }),
    })
    return mapStockEquipmentAssignmentSummary(stockEquipmentAssignmentSummaryRawSchema.parse(raw))
}

export async function applyStockEquipmentReassignment(
    jobId: string,
    input: ApplyStockEquipmentReassignmentInput,
): Promise<StockEquipmentAssignmentSummary> {
    const body = applyStockEquipmentReassignmentInputSchema.parse(input)
    const raw = await apiFetch<unknown>(`/jobs/${jobId}/stock-equipment-reassignments`, {
        method: 'POST',
        body: JSON.stringify({
            rental_asset_type_id: body.rentalAssetTypeId,
            quantity: body.quantity,
        }),
    })
    return mapStockEquipmentAssignmentSummary(stockEquipmentAssignmentSummaryRawSchema.parse(raw))
}
